import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const UserAvatar = styled(UserInitials)<{ pictureUrl?: string }>`
  margin-right: 12px;
  font-size: ${(props) => (props.pictureUrl ? '0' : '12px')};
`;

export const UploadProfilePictureButton = styled.button<{
  isUploadPictureOpen?: boolean;
  hasPictureUploaded?: boolean;
}>`
  background: ${(props) => (props.hasPictureUploaded ? '#001b4b5c' : '#3f5e9b')};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  margin-right: 12px;
  opacity: ${(props) => (props.isUploadPictureOpen ? '1' : '0')};
  transition: opacity 0.1s ease;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    top: -2px;
  }
`;

export const ProfilePictureArea = styled.div`
  position: relative;

  &:hover {
    ${UploadProfilePictureButton} {
      opacity: 1;
    }
  }
`;

export const FloatingButtons = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 4;
`;

export const FloatingButton = styled.button<{ isRedColor?: boolean }>`
  font-size: 14px;
  display: flex;
  align-items: center;
  line-height: 21px;
  padding: 5px 12px;
  color: ${(props) =>
    props.isRedColor ? props.theme.colors.warning : props.theme.colors['neutral-100']};
  svg {
    margin-right: 4px;
    font-size: 14px;
  }
`;
